import React from 'react';

export function BentoGrid() {
  // Card style variants - white cards with black text
  const cardStyles = {
    glass: "bg-white",
    gradientBlue: "bg-white",
    gradientPink: "bg-white",
    gradientMixed: "bg-white",
  };

  return (
    <div className="w-full mt-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-4 auto-rows-[120px] md:auto-rows-[140px]">
          {/* Row 1 - Asymmetric top */}
          {/* Schmalsoft KI - Compact width */}
          <div className={`col-span-12 md:col-span-6 rounded-3xl p-4 md:p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientMixed}`}>
            <div>
              <p className="text-sm md:text-lg lg:text-xl text-gray-900 leading-tight">
                Durch <span className="text-base md:text-2xl lg:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-pink-600">schmalsoft KI</span> zu deinem<br />
                noch persönlicheren <span className="text-base md:text-2xl lg:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-pink-600">Radio-Erlebnis</span>
              </p>
            </div>
          </div>

          {/* Echte Musik */}
          <div className={`col-span-6 md:col-span-3 rounded-3xl p-4 md:p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientBlue}`}>
            <div>
              <p className="text-sm md:text-lg lg:text-xl text-gray-900 leading-tight">
                Keine KI-Musik mehr durch<br />
                <span className="text-xl md:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-pink-600">100+</span> neue Songs
              </p>
            </div>
          </div>

          {/* New Feature Card */}
          <div className={`col-span-6 md:col-span-3 rounded-3xl p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientPink}`}>
            <div>
              <p className="text-lg md:text-xl text-gray-900 leading-tight">
                <span className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-blue-600">10x</span> bessere Moderationen
              </p>
            </div>
          </div>

          {/* Row 2 - Middle with center */}
          {/* Interaktion - Tall (2 rows) */}
          <div className={`col-span-6 md:col-span-3 md:row-span-2 rounded-3xl p-4 md:p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientBlue}`}>
            <div>
              <p className="text-sm md:text-lg lg:text-xl text-gray-900 leading-tight">
                Noch mehr <span className="text-xl md:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-pink-600">Interaktions-Möglichkeiten</span> mit Chris & Lena
              </p>
            </div>
          </div>

          {/* Center - schmalgsicht v2 - Hidden on mobile */}
          <div
            className="hidden md:flex md:col-span-6 md:row-span-2 rounded-3xl p-6 h-full items-center justify-center relative overflow-hidden"
            style={{
              background: 'linear-gradient(135deg, rgba(59,130,246,0.35) 0%, rgba(168,85,247,0.3) 50%, rgba(236,72,153,0.35) 100%)',
              backdropFilter: 'blur(24px)'
            }}
          >
            <div className="flex flex-row items-center justify-center gap-5">
              {/* Links: schmal + gsicht untereinander */}
              <div className="flex flex-col leading-none text-right">
                <span className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white tracking-tight" style={{ lineHeight: '0.85' }}>
                  schmal
                </span>
                <span className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white tracking-tight" style={{ lineHeight: '0.85' }}>
                  gs<span className="text-pink-500">ich</span>t
                </span>
              </div>

              {/* Rechts: Gradient-Quadrat mit v2 */}
              <div className="bg-gradient-to-br from-blue-500 to-pink-500 rounded-xl lg:rounded-2xl flex items-center justify-center aspect-square h-[5.5rem] lg:h-[6.5rem] xl:h-[8rem]">
                <span className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white">
                  v2
                </span>
              </div>
            </div>
          </div>

          {/* Feature 8 - Web-Suche (moved up) */}
          <div className={`col-span-6 md:col-span-3 md:row-span-2 rounded-3xl p-4 md:p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientMixed}`}>
            <div>
              <p className="text-sm md:text-lg lg:text-xl text-gray-900 leading-tight">
                Dank <span className="text-xl md:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-pink-600">Web-Suche</span> jetzt mit noch aktuelleren Themen
              </p>
            </div>
          </div>

          {/* Row 3 - Bottom asymmetric */}
          {/* Stündliche News - Wide */}
          <div className={`col-span-12 md:col-span-6 rounded-3xl p-4 md:p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientBlue}`}>
            <div>
              <p className="text-sm md:text-lg lg:text-xl text-gray-900 leading-tight">
                Immer auf den neusten Stand sein dank <span className="text-base md:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-pink-600">stündlicher Nachrichten</span> von Chris & Lena
              </p>
            </div>
          </div>

          {/* Feature 7 - Musikwunsch */}
          <div className={`col-span-6 md:col-span-3 rounded-3xl p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientPink}`}>
            <div>
              <p className="text-lg md:text-xl text-gray-900 leading-tight">
                Wünsch dir deinen<br />
                <span className="text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-blue-600">Lieblings-Song</span>
              </p>
            </div>
          </div>

          {/* Placeholder - Features folgen bald */}
          <div className={`col-span-6 md:col-span-3 rounded-3xl p-6 h-full flex flex-col items-center justify-center text-center  ${cardStyles.gradientBlue}`}>
            <div>
              <p className="text-lg md:text-xl text-gray-900 leading-tight">
                Weitere <span className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-pink-600">Features</span> folgen bald
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
